import { defineComponent as _defineComponent } from 'vue'
import { computed, ref } from 'vue';

import Provider from '@/interfaces/provider';

import ProviderIcon from '@/components/picture/ProviderIcon.vue';
import HiddenHorizontalScrollbar from '@/components/HiddenHorizontalScrollbar.vue';

import { FilterCollection } from '@/stores/filter.store';
import { faTimes } from '@fortawesome/free-solid-svg-icons';

interface FilterBarProviderMultiProps {
	providers: Provider[];
	currentFilters: FilterCollection;
	userSelectedPackages: string[];
	updateRouteState: boolean;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'FilterBarProviderMulti',
  props: {
    providers: null,
    currentFilters: null,
    userSelectedPackages: null,
    updateRouteState: { type: Boolean }
  },
  emits: ["toggle"],
  setup(__props: any, { emit }: { emit: ({
	(
		e: 'toggle',
		data: {
			filterName: keyof FilterCollection;
			value: any;
			selectedState: 1 | 0;
			updateRouteState?: boolean;
			userSelectedPackages?: string[];
			trackEvent?: boolean;
		}
	): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
	providers: Provider[];
	currentFilters: FilterCollection;
	userSelectedPackages: string[];
	updateRouteState: boolean;
};





const collapsed = ref(true);

const extraProviders = computed(() => `+${props.providers.length - 3}`);

function toggleCollapsed() {
	collapsed.value = !collapsed.value;
}

function toggleProvider(providerName: string) {
	const isActive: 1 | 0 = props.currentFilters.providers.includes(providerName) ? 0 : 1;
	const toggleData = {
		filterName: 'providers' as keyof FilterCollection,
		value: providerName,
		selectedState: isActive,
		updateRouteState: props.updateRouteState,
		userSelectedPackages: props.userSelectedPackages ?? [],
		trackEvent: true,
	};

	emit('toggle', toggleData);
}

return { __sfc: true,props, emit, collapsed, extraProviders, toggleCollapsed, toggleProvider, ProviderIcon, HiddenHorizontalScrollbar, faTimes }
}

})